<div class="h-100-p">
    <div class="notification-wrapper h-100-p" id="notification-container">
        <div class="notification-header h-64 pt-20 pb-20 pl-24 pr-24" fxLayout="row"
             fxLayoutAlign="space-between center">
            <div>
                <!-- <p class="p-0 m-0 font-size-18 legacy-bold">Select Assistant </p> -->
            </div>
            <div class="chat-icon">
                <!--<img src="{{botImage}}" alt="">-->
              <mat-icon class="i-sn-communication"></mat-icon>
            </div>
        </div>
        <div class="notification-body h-100-p pt-20 pb-20 pl-24 pr-24">
            <!-- shows notifications -->
            <div *ngIf="notifications && notifications.length">
                <div class="single-notification mb-24 cursor-pointer" *ngFor="let notification of notifications" (click)="gotoDetails(notification.DetailsInfo)">
                    <div class="notification-container" [ngClass]="{'unread-notification' :!notification.IsRead }">
                        <div class="single-notification-header pl-12 pr-12" fxLayout="row" fxLayoutAlign="space-between center"
                             *ngIf="notification.DenormalizedPayload">
                            <div fxFlex="60" fxLayout="row" class="mr-8" fxLayoutAlign="start center">
                                <i class="fa fa-user-circle font-size-16 line-height-24"></i>
                                <p class="p-0 m-0 font-size-12 line-height-12 primary-text-color calibri-font-regular text-truncate">
                                    {{notification?.DenormalizedPayload['senderName']}}</p>
                            </div>
                            <div fxFlex="30" class="text-left">
                                <p class="p-0 m-0 primary-text-color font-size-12 italic"
                                   *ngIf="notification.DenormalizedPayload.time">{{notification.DenormalizedPayload.time |
                                    date:'mediumDate'}}</p>
                            </div>
                        </div>
                        <div class="single-notification-body pt-8 pl-16 pr-16 pb-16" *ngIf="notification.DenormalizedPayload">
                            <p class="font-size-16 primary-text-color p-0 mt-0 mb-4 line-height-16 legacy-bold"
                               *ngIf="notification?.DenormalizedPayload?.title">{{notification?.DenormalizedPayload?.title}}</p>

                            <p class="p-0 m-0 primary-text-color font-size-14 line-height-20 word-break"
                               *ngIf="notification.DenormalizedPayload.message">{{notification.DenormalizedPayload.message}}<br><span class="cursor-pointer view-more" (click)="gotoDetails(notification.DetailsInfo)">{{'QUICK_PANEL.VIEW_DETAILS'| translate}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- if no notificaiton found -->
            <div *ngIf="notifications && !notifications.length" fxLayout="row"
                 fxLayoutAlign="center center">
                <span>{{'COMING_SOON'| translate}}</span>
            </div>
            <!-- if notification length gets higher -->
            <div class="all-notification" *ngIf="notifications && notifications.length && (displayingNotificationcount < totalNotification )">
                <button mat-button mat-raised-button class="w-100-p pt-8 pb-8 legacy-bold" (click)="gotoBot()">{{'QUICK_PANEL.VIEW_ALL'| translate}}</button>
            </div>
        </div>
    </div>
</div>
